<template>
    <div class="invoice-actions d-flex align-items-center justify-content-start">
        <div class="d-none d-md-flex align-items-center action-icons">
            <KvTooltip :text="t('invoices-view_details')">
                <kv-button 
                    variant="text" 
                    size="small" 
                    prepend-icon="ui-eye" 
                    class="btn-view"
                    @click.prevent="$emit('view', invoice)"
                ></kv-button>
            </KvTooltip>
            
            <KvTooltip :text="invoice.status === 'draft' ? t('invoices-delete_invoice') : t('invoices-delete_only_draft_hint')">
                <kv-button 
                    v-if="isAdmin"
                    variant="text"
                    size="small"
                    prepend-icon="ui-trash-01"
                    :class="{ 'btn-delete': true, 'disabled': invoice.status !== 'draft' }"
                    :disabled="invoice.status !== 'draft'"
                    @click.prevent="invoice.status === 'draft' && $emit('delete', invoice)"
                ></kv-button>
            </KvTooltip>
        </div>

        <div class="dropdown d-md-none">
            <button class="btn btn-link btn-sm dropdown-toggle no-arrow" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <Icon icon-class="ui-list" size="4" />
            </button>
            <div class="dropdown-menu dropdown-menu-right">
                <a class="dropdown-item" href="#" @click.prevent="$emit('view', invoice)">
                    <Icon icon-class="ui-eye" size="3" class="mr-2 text-muted" /> {{ t('invoices-view_details') }}
                </a>
                
                <template v-if="isAdmin">
                    <div class="dropdown-divider"></div>
                    
                    <a v-if="invoice.status === 'draft'" class="dropdown-item text-danger" href="#" @click.prevent="$emit('delete', invoice)">
                        <Icon icon-class="ui-trash-01" size="3" class="mr-2" /> {{ t('invoices-delete_invoice') }}
                    </a>
                </template>

                <template v-else>
                    <a v-if="['pending'].includes(invoice.status) && (invoice.bank_slip_url || invoice.payment_link_url)" class="dropdown-item font-weight-500" href="#" @click.prevent="$emit('pay', invoice)">
                        <Icon icon-class="ui-credit-card-refresh" size="3" class="mr-2" /> {{ t('invoices-pay_now') }}
                    </a>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from "../../components/icon/icon.vue";
import KvButton from "../../components/form/kv-button.vue";

export default {
    name: "invoice-actions-menu",
    components: {
        Icon,
        KvButton
    },
    props: {
        invoice: {
            type: Object,
            required: true
        },
        isAdmin: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<style lang="scss" scoped>
.invoice-actions {
    .action-icons {
        gap: 8px;
    }

    .btn-view {
        color: #9CA3AF !important;
        &:hover {
            color: #4B5563 !important;
            background-color: #F3F4F6 !important;
        }
        ::v-deep .ui-icon {
            color: inherit !important;
        }
    }

    .btn-delete {
        color: #EF4444 !important;
        &:hover {
            color: #B91C1C !important;
            background-color: #FEF2F2 !important;
        }
        ::v-deep .ui-icon {
            color: inherit !important;
        }

        &.disabled {
            opacity: 0.4;
            cursor: not-allowed;
            pointer-events: none;
            color: #9CA3AF !important;
        }
    }

    .btn-link {
        color: #9CA3AF;
        padding: 0;
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 6px;
        
        &:hover {
            background-color: #F3F4F6;
            color: #4B5563;
        }

        &.no-arrow::after {
            display: none;
        }
    }

    .dropdown-menu {
        border-radius: 8px;
        border: 1px solid #E5E7EB;
        box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
        padding: 8px;

        .dropdown-item {
            padding: 8px 12px;
            border-radius: 6px;
            font-size: 13px;
            color: #374151;
            display: flex;
            align-items: center;

            i {
                width: 16px;
                text-align: center;
            }

            &:hover {
                background-color: #F9FAFB;
            }

            &.text-danger:hover {
                background-color: #FEF2F2;
            }
        }
    }
}
</style>
